import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Row, Col, Alert } from 'react-bootstrap';
import Container from '../components/Container';
import SectionHeader from '../components/SectionHeader';
import Button from '../components/Button';
import { useAuth } from '../context/AuthContext';
import { LogIn } from 'lucide-react';
import '../styles/components.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: 'hervekwengoua@gmail.com',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(formData.email, formData.password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6} md={8}>
            <div className="card-modern">
              <SectionHeader 
                title="Connexion Administrateur"
                subtitle="Connectez-vous pour accéder à l'administration"
              />

              {error && (
                <Alert variant="danger" className="mb-4">
                  {error}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group-modern">
                  <label htmlFor="email" className="form-label-modern">
                    Email <span style={{ color: 'var(--color-error)' }}>*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control-modern"
                    placeholder="hervekwengoua@gmail.com"
                    required
                    readOnly
                    style={{ backgroundColor: 'var(--color-bg)', cursor: 'not-allowed' }}
                  />
                  <small style={{ color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
                    Email administrateur fixe
                  </small>
                </div>

                <div className="form-group-modern">
                  <label htmlFor="password" className="form-label-modern">
                    Mot de passe <span style={{ color: 'var(--color-error)' }}>*</span>
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="form-control-modern"
                    placeholder="Entrez votre mot de passe"
                    required
                    autoFocus
                  />
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  disabled={loading}
                  style={{ width: '100%', marginTop: 'var(--spacing-md)' }}
                >
                  {loading ? (
                    'Connexion...'
                  ) : (
                    <>
                      <LogIn size={20} style={{ marginRight: '0.5rem' }} />
                      Se connecter
                    </>
                  )}
                </Button>
              </form>

              <div style={{ marginTop: 'var(--spacing-md)', textAlign: 'center' }}>
                <Link 
                  to="/" 
                  style={{ 
                    color: 'var(--color-text-light)', 
                    fontSize: 'var(--font-size-sm)',
                    textDecoration: 'none'
                  }}
                >
                  ← Retour à l'accueil
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
